module.exports = __webpack_public_path__ + "static/media/acai_berry_big_mask.e5651a20.png";